import React, { useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"
import birthdayService from "../../services/data/birthday.service"
import companyAnniversaryService from "../../services/data/company-anniversary.service"

export default function BirthdaySettings() {
    const companyId = localStorage.getItem("companyId")

    const [config, setConfig] = useState(null)
    const [annivConfig, setAnnivConfig] = useState(null)
    const [loading, setLoading] = useState(false)

    const [savingBd, setSavingBd] = useState(false)
    const [savedBd, setSavedBd] = useState(false)
    const [savingAn, setSavingAn] = useState(false)
    const [savedAn, setSavedAn] = useState(false)

    useEffect(() => {
        setLoading(true)
        const payload = { company_id: companyId }
        Promise.all([
            birthdayService.getConfig(payload),
            companyAnniversaryService.getConfig(payload).catch(() => null),
        ])
            .then(([bd, an]) => { setConfig(bd); setAnnivConfig(an) })
            .catch(console.error)
            .finally(() => setLoading(false))
    }, [])

    function handleChangeBd(field, value) {
        setConfig(prev => ({ ...prev, [field]: value }))
    }

    function handleChangeAn(field, value) {
        setAnnivConfig(prev => ({ ...prev, [field]: value }))
    }

    function handleSaveBd(e) {
        e.preventDefault()
        setSavingBd(true)
        setSavedBd(false)
        birthdayService.updateConfig({ ...config, company_id: companyId })
            .then(setConfig)
            .then(() => setSavedBd(true))
            .catch(console.error)
            .finally(() => setSavingBd(false))
    }

    function handleSaveAn(e) {
        e.preventDefault()
        setSavingAn(true)
        setSavedAn(false)
        companyAnniversaryService.updateConfig({ ...annivConfig, company_id: companyId })
            .then(setAnnivConfig)
            .then(() => setSavedAn(true))
            .catch(console.error)
            .finally(() => setSavingAn(false))
    }

    if (loading) return <div className="text-muted">Carregando configurações...</div>

    return (
        <div>
            {/* Aniversários de nascimento */}
            <h6 className="fw-bold text-default mb-3">
                <FontAwesomeIcon icon={solid("cake-candles")} className="me-2 text-green" />
                Aniversários de Nascimento
            </h6>

            {savedBd && <div className="alert alert-success">Configurações salvas com sucesso!</div>}

            {config && (
                <form onSubmit={handleSaveBd} className="mb-5">
                    <div className="mb-3">
                        <label className="form-label fw-semibold">Dias de antecedência para lembrete</label>
                        <input
                            type="number"
                            className="form-control"
                            min={0}
                            max={30}
                            value={config.alert_days_before}
                            onChange={e => handleChangeBd("alert_days_before", parseInt(e.target.value))}
                        />
                        <div className="form-text">Ex: 3 = lembrete 3 dias antes do aniversário</div>
                    </div>

                    <div className="mb-3 form-check form-switch d-flex align-items-center gap-2 ps-0">
                        <input
                            type="checkbox"
                            className="form-check-input ms-0 mt-0"
                            id="send_monthly_email"
                            checked={config.send_monthly_email}
                            onChange={e => handleChangeBd("send_monthly_email", e.target.checked)}
                        />
                        <label className="form-check-label mb-0" htmlFor="send_monthly_email">
                            Enviar email mensal com lista de aniversariantes para gestores (dia 1 do mês)
                        </label>
                    </div>

                    <div className="mb-3 form-check form-switch d-flex align-items-center gap-2 ps-0">
                        <input
                            type="checkbox"
                            className="form-check-input ms-0 mt-0"
                            id="send_ecard"
                            checked={config.send_ecard}
                            onChange={e => handleChangeBd("send_ecard", e.target.checked)}
                        />
                        <label className="form-check-label mb-0" htmlFor="send_ecard">
                            Enviar e-card personalizado para o aniversariante no dia
                        </label>
                    </div>

                    <div className="mb-3 form-check form-switch d-flex align-items-center gap-2 ps-0">
                        <input
                            type="checkbox"
                            className="form-check-input ms-0 mt-0"
                            id="allow_day_off"
                            checked={config.allow_day_off}
                            onChange={e => handleChangeBd("allow_day_off", e.target.checked)}
                        />
                        <label className="form-check-label mb-0" htmlFor="allow_day_off">
                            Presente digital: permitir day-off automático no aniversário
                        </label>
                    </div>

                    {config.allow_day_off && (
                        <div className="mb-3">
                            <label className="form-label fw-semibold">Valor do vale-presente (R$)</label>
                            <input
                                type="number"
                                className="form-control"
                                min={0}
                                step="0.01"
                                value={config.gift_voucher_value || ""}
                                onChange={e => handleChangeBd("gift_voucher_value", e.target.value)}
                            />
                        </div>
                    )}

                    <button type="submit" className="btn btn-success btn-sm btn-rounded px-4" disabled={savingBd}>
                        <FontAwesomeIcon icon={solid("floppy-disk")} className="me-2" />
                        {savingBd ? "Salvando..." : "Salvar"}
                    </button>
                </form>
            )}

            {/* Aniversários de empresa */}
            <hr />

            <h6 className="fw-bold text-default mb-3 mt-4">
                <FontAwesomeIcon icon={solid("building")} className="me-2 text-green" />
                Aniversários por Tempo de Empresa
            </h6>

            {savedAn && <div className="alert alert-success">Configurações salvas com sucesso!</div>}

            {annivConfig && (
                <form onSubmit={handleSaveAn}>
                    <div className="mb-3">
                        <label className="form-label fw-semibold">Frequência de envio</label>
                        <select
                            className="form-select"
                            value={annivConfig.frequency}
                            onChange={e => handleChangeAn("frequency", e.target.value)}
                        >
                            <option value="yearly">Todo ano (1º, 2º, 3º... aniversário)</option>
                            <option value="every_5_years">A cada 5 anos (5º, 10º, 15º...)</option>
                        </select>
                        <div className="form-text">Define quais aniversários geram lembretes e notificações.</div>
                    </div>

                    <div className="mb-3 form-check form-switch d-flex align-items-center gap-2 ps-0">
                        <input
                            type="checkbox"
                            className="form-check-input ms-0 mt-0"
                            id="an_send_monthly_email"
                            checked={annivConfig.send_monthly_email}
                            onChange={e => handleChangeAn("send_monthly_email", e.target.checked)}
                        />
                        <label className="form-check-label mb-0" htmlFor="an_send_monthly_email">
                            Enviar email mensal com lista de aniversários de empresa para gestores (dia 1 do mês)
                        </label>
                    </div>

                    <div className="mb-3 form-check form-switch d-flex align-items-center gap-2 ps-0">
                        <input
                            type="checkbox"
                            className="form-check-input ms-0 mt-0"
                            id="an_send_ecard"
                            checked={annivConfig.send_ecard}
                            onChange={e => handleChangeAn("send_ecard", e.target.checked)}
                        />
                        <label className="form-check-label mb-0" htmlFor="an_send_ecard">
                            Enviar e-card personalizado para o colaborador no dia do aniversário de empresa
                        </label>
                    </div>

                    <div className="mb-3 form-check form-switch d-flex align-items-center gap-2 ps-0">
                        <input
                            type="checkbox"
                            className="form-check-input ms-0 mt-0"
                            id="an_notify_superior"
                            checked={annivConfig.notify_superior}
                            onChange={e => handleChangeAn("notify_superior", e.target.checked)}
                        />
                        <label className="form-check-label mb-0" htmlFor="an_notify_superior">
                            Notificar gestor imediato no dia do aniversário de empresa
                        </label>
                    </div>

                    <button type="submit" className="btn btn-success btn-sm btn-rounded px-4" disabled={savingAn}>
                        <FontAwesomeIcon icon={solid("floppy-disk")} className="me-2" />
                        {savingAn ? "Salvando..." : "Salvar"}
                    </button>
                </form>
            )}
        </div>
    )
}
